var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',{attrs:{"color":"primary","label":_vm.label},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }